<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">快递物流行业解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        近年来，中国快递物流行业在电商蓬勃发展的带动下，呈现出持续高速增长的态势。2024 年，中国快递业务量已成功突破
                        1200 亿件大关，网络零售额更是达到 15.67
                        万亿元。在如此庞大的业务规模下，物流环节的高效运转成为行业竞争的核心焦点。热敏打印机作为快递物流信息数字化传递的关键设备，其打印速度、稳定性、兼容性以及智能化管理能力，直接关系到快递分拣效率、信息准确率和客户服务质量，是支撑快递物流行业数字化转型的重要基石。

                        从快递订单生成到包裹最终送达，热敏打印的面单、标签等载体贯穿始终，承载着收件信息、分拣编码、路由规划等关键数据。高效可靠的热敏打印解决方案，能够帮助物流企业减少信息误差、降低人工成本、提升周转效率，在激烈的市场竞争中构建核心优势。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block2" v-if="activeTabIndex === 0">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">打印速度跟不上分拣节奏</div>
                        <div class="business-block-item-text">
                            传统打印机在面对海量包裹的面单打印需求时，速度明显不足，导致分拣环节出现拥堵，影响整体周转效率。
                        </div>
                        <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">设备稳定性差易中断作业</div>
                        <div class="business-block-item-text">
                            在高强度、长时间的连续打印作业中，传统打印机容易出现卡纸、打印头故障等问题，导致作业中断，增加人工排查和维修成本。
                        </div>
                        <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">多区域协同打印管理难</div>
                        <div class="business-block-item-text">
                            大型分拨中心往往分为多个分拣区域，需要多台打印机协同工作，但传统设备缺乏统一的管理平台，难以实时监控设备状态和打印任务进度，容易出现任务分配不均、设备闲置或过载等问题。
                        </div>
                        <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
                <div class="business-block2" v-else-if="activeTabIndex === 1">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">设备成本高且维护麻烦</div>
                        <div class="business-block-item-text">
                            部分高端打印机采购成本高，而低价设备又存在稳定性差、故障率高的问题，频繁维修导致维护成本增加，给中小型末端网点带来经济压力。
                        </div>
                        <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">多品牌面单兼容难度大</div>
                        <div class="business-block-item-text">
                            末端网点往往需要处理多家快递公司的包裹，不同品牌面单格式各异，传统打印机兼容性差，需要频繁调整设置或更换设备，操作繁琐且易出错。
                        </div>
                        <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">操作人员上手慢效率低</div>
                        <div class="business-block-item-text">
                            基层快递员对复杂设备的操作能力有限，传统打印机操作界面复杂，学习成本高，导致打印效率低，甚至出现打印错误等问题。
                        </div>
                        <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
                <div class="business-block2" v-else-if="activeTabIndex === 2">
                    <div class="business-block-item1 business-block-item2"></div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">设备便携性差影响移动作业</div>
                        <div class="business-block-item-text">
                            传统打印机体积大、重量沉，不便于快递员随身携带，在上门揽收过程中使用不便，影响揽收效率。
                        </div>
                        <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">无线连接不稳定数据同步难</div>
                        <div class="business-block-item-text">
                            在户外或信号较差的区域，传统打印机无线连接不稳定，容易出现面单数据传输失败或延迟的问题，导致面单打印不及时，影响客户体验。
                        </div>
                        <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">续航能力不足限制作业时长</div>
                        <div class="business-block-item-text">
                            移动揽收过程中缺乏稳定电源，传统打印机续航能力差，需要频繁充电，限制了快递员的外出作业时长。
                        </div>
                        <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <template v-if="activeTabIndex === 0">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/G31_G41.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-G41</span> 工业级热敏打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                高速打印机，适合大批量订单连续打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：300mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：100-120mm<br/>
                                接口：usb和以太网接口<br/>
                                日均打印量：50000-100000单<br/>
                                适用场景：适用于快递分拨中心、大型中转场等高强度打印场景。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持多设备集中监控，可实时显示各打印机的工作状态、任务队列、耗材余量等信息；具备任务优先级设置功能，可根据分拣需求调整打印任务顺序；提供故障预警和自动报警功能，便于运维人员及时处理设备问题，保障打印作业连续稳定。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/gj-bg.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="../ECommerce/images/printer1.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-202</span> 系列标准型热敏打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                无纸仓设计不占空间，纸张自动进退更环保
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：150mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：50-100mm<br/>
                                接口：usb<br/>
                                日均打印量：1000-5000单<br/>
                                适用场景：末端快递网点、社区驿站等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持一键导入各快递公司面单模板，自动适配打印格式；提供简单易用的操作界面，支持批量打印和预览功能，减少打印错误；具备设备状态监控功能，及时提醒耗材更换，保障打印作业顺畅。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/gj-bg.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/KM-360AN.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-360A</span> 便携无线热敏打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                机器小巧便携，内置大容量电池支持长时间外出打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：100mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：50-80mm<br/>
                                接口：usb、蓝牙、WiFi<br/>
                                日均打印量：单次充电可打印1000-3000单<br/>
                                适用场景：快递员移动揽收、上门取件等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持与主流快递 App 无缝对接，实时同步订单信息；提供面单模板快速选择和编辑功能，支持现场录入订单信息并即时打印；具备打印记录查询功能，便于快递员核对揽收包裹信息。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/gj-bg.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        某全国性快递企业分拨中心在引入工业级高速热敏打印机和番茄打印管家软件后，面单打印效率提升了 2
                        倍，分拣环节拥堵问题得到有效解决，大促期间日均处理包裹量从原来的 80 万件提升至 150 万件，设备故障率降低了
                        60%，运维成本减少了 40%。
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        某社区快递驿站引入快麦 KM-202 系列打印机和番茄打印管家软件后，设备采购成本降低了 30%，操作人员上手时间从原来的
                        1 天缩短至 1 小时，面单打印错误率从 5% 降至 1% 以下，日均包裹处理效率提升了 40%。
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        某快递企业为旗下快递员配备快麦便携式无线热敏打印机和番茄打印管家移动版软件后，快递员上门揽收效率提升了
                        50%，面单数据同步错误率降至 0.5% 以下，单次外出作业时长延长了 2 小时，客户对揽收服务的满意度提高了
                        30%。
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "KDWL",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '快递分拨中心',
                    title: '快递分拨中心',
                    subtitle: '快递分拨中心是物流网络的核心枢纽，承担着区域内快递包裹的集中分拣、中转任务。日均处理包裹量可达数十万甚至上百万件，尤其在电商大促期间，包裹量会呈现爆发式增长，对分拣效率和信息准确性提出极高要求。分拨中心需要对包裹进行快速面单打印、分拣标签打印等操作，以确保包裹能够准确、及时地发往下一环节。',
                    solution: '部署工业级高速热敏打印机 和 番茄打印管家软件，构建分拨中心高效打印管理体系。',
                    goods: [
                        {
                            title: '极致速度提升分拣效率',
                            text: '工业级热敏打印机打印速度可达 300mm/s 以上，能够快速完成海量面单和标签的打印任务，与高速分拣设备无缝对接，确保分拣环节高效运转。'
                        },
                        {
                            title: '稳定可靠保障连续作业',
                            text: '采用高品质打印头和耐用机身设计，设备可实现24 小时连续稳定运行，有效减少卡纸、故障等问题，降低作业中断风险，保障分拨中心全天候高效作业。'
                        },
                        {
                            title: '智能管理实现协同高效',
                            text: '通过番茄打印管家软件，可对分拨中心内所有打印机进行集中管理，实时监控设备状态、打印任务进度和耗材余量，实现打印任务的智能分配和调度，避免设备闲置或过载，提高整体协同效率。'
                        },
                    ]
                },
                {
                    tabName: '末端快递网点',
                    title: '末端快递网点',
                    subtitle: '末端快递网点是快递服务的最后一公里关键节点，负责区域内包裹的接收、暂存、派送以及揽收业务。网点规模大小不一，日均处理包裹量从数百到数千件不等，操作人员多为基层快递员，对设备的易用性和成本敏感度较高。网点需要打印派送面单、揽收面单等，且面临多品牌快递面单格式不统一的问题。',
                    solution: '部署快麦标准型热敏打印机 和番茄打印管家软件，打造末端网点低成本、易操作的打印解决方案。',
                    goods: [
                        {
                            title: '高性价比降低运营成本',
                            text: '快麦标准型热敏打印机价格亲民，同时具备稳定的性能，故障率低，减少了设备采购和维护成本，适合末端网点的成本预算需求。'
                        },
                        {
                            title: '全兼容适配多品牌面单',
                            text: '配合番茄打印管家软件，可兼容各大快递公司的面单格式，无需频繁调整设置或更换设备，操作人员只需简单操作即可完成不同品牌面单的打印，提高工作效率。'
                        },
                        {
                            title: '简单易用降低学习成本',
                            text: '打印机操作界面简洁直观，所有交互逻辑统一，操作人员经过简单培训即可快速上手，减少因操作不当导致的错误，提升打印效率。'
                        },
                    ]
                },
                {
                    tabName: '移动揽收场景',
                    title: '移动揽收场景',
                    subtitle: '移动揽收是快递员上门收取客户包裹的业务环节，需要在客户现场完成订单信息录入和面单打印。揽收场景具有流动性强、环境多变的特点，对打印机的便携性、续航能力和无线连接能力要求较高，同时需要支持与快递 App 实时数据同步。',
                    solution: '部署快麦便携式无线热敏打印机和番茄打印管家移动版软件，满足移动揽收场景的打印需求。',
                    goods: [
                        {
                            title: '极致便携提升移动灵活性',
                            text: '便携式热敏打印机体积小巧、重量轻，便于快递员随身携带，可轻松应对上门揽收、户外摆摊等移动场景，提高作业灵活性。'
                        },
                        {
                            title: '稳定无线保障数据同步',
                            text: '支持 usb、WiFi 等多种无线连接方式，连接稳定可靠，可与快递 App 实时同步订单数据，确保面单信息准确无误，避免数据传输失败或延迟问题。'
                        },
                        {
                            title: '长效续航延长作业时间',
                            text: '配备大容量可充电电池，单次充电可支持连续打印数千张面单，满足快递员全天移动揽收的打印需求，减少充电次数，延长外出作业时间。'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
